<template>
  <div id="header" ref="mainHeader" :class="[isIos ? 'header-ios' : '']">
    <div id="top-wrapper">
      <!-- Desktop: single row -->
      <div class="desktop-header d-none d-xl-flex">
        <div class="d-flex align-items-center">
          <a @click="handleHomeClick">
            <img
              class="logo"
              alt="National Garden Scheme logo"
              src="@/assets/images/logo.png">
          </a>
          <div class="find-a-garden-banner">
            Find a garden
          </div>
          <div class="divider-line"></div>
          <b-button v-if="!hideSearch" class="new-search-btn" @click="$router.push('/')">
            <font-awesome-icon :icon="['far', 'search']"/>
            Edit search
          </b-button>
          <b-button
            class="back-to-ngs-link p-0"
            href="https://ngs.org.uk"
            variant="link"
          >
            <font-awesome-icon :icon="['fal', 'arrow-left']"/>
            <span>Back to main site</span>
          </b-button>
        </div>
        <div class="d-flex align-items-center">
          <b-button
            class="contact-us-link p-0"
            href="https://ngs.org.uk/who-we-are/contact-us/"
            variant="link"
          >
            Contact us
          </b-button>
          <b-button
            class="login-link p-0"
            href="https://ngs.org.uk/account/"
            variant="link"
          >
            Login / Register
          </b-button>
        </div>
      </div>

      <!-- Mobile (sub-xl): single row keeps the map tall and avoids the
           Back-to-main-site link which boots wrapped-app users out of the app. -->
      <div class="mobile-header d-xl-none">
        <div class="mobile-header__row-1">
          <a @click="handleHomeClick">
            <img
              class="logo"
              alt="National Garden Scheme logo"
              src="@/assets/images/logo.png">
          </a>
          <b-button v-if="!hideSearch" class="new-search-btn" @click="$router.push('/')">
            <font-awesome-icon :icon="['far', 'search']"/>
            Edit search
          </b-button>
          <b-button
            class="contact-us-link p-0"
            href="https://ngs.org.uk/who-we-are/contact-us/"
            variant="link"
          >
            Contact us
          </b-button>
        </div>
      </div>
    </div>
    <div v-show="!hideFilters" class="filters-wrapper">
      <ListHeader/>
      <FilterButtons/>
    </div>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core'
import FilterButtons from '@/components/header/filters/FilterButtons'
import ListHeader from '@/components/gardenList/ListHeader'

export default {
  name: 'Header',

  components: {
    FilterButtons,
    ListHeader,
  },

  props: {
    hideSearch: {
      type: Boolean,
      default: false,
    },
    hideFilters: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isIos() {
      return Capacitor.isNativePlatform()
    },
  },

  methods: {
    handleHomeClick() {
      const path = '/'
      if (this.$route.path !== path) this.$router.push(path)
    },
  },
}
</script>

<style lang="scss">
#header {
  #top-wrapper {
    background-color: $color-yellow-main;

    .logo {
      height: 56px;
      width: auto;
      cursor: pointer;
    }

    .find-a-garden-banner,
    .contact-us-link,
    .login-link {
      font-size: 25px;
      color: #000;
      font-family: "NGS 2017", "Inter", sans-serif;
      text-transform: uppercase;
      margin-inline: 20px;
    }

    .contact-us-link,
    .login-link {
      font-size: 19px;
    }

    .new-search-btn {
      padding: 12px;
      background-color: #000;
      color: #FFF;
      font-family: "Gill Sans";
      font-size: 18px;
      font-weight: 600;
      border: none;
      border-radius: 0;
    }

    .back-to-ngs-link {
      color: #000;
      font-family: "NGS 2017";
      font-size: 22px;
      font-style: normal;
      font-weight: 400;

      span {
        margin-left: 8px;
      }
    }

    .desktop-header {
      align-items: center;
      padding: 12px;
      display: flex;
      justify-content: space-between;

      .divider-line {
        display: flex;
        width: 1px;
        align-self: stretch;
        background: var(--Navy-20, rgba(28, 36, 51, 0.20));
      }

      .new-search-btn {
        margin-left: 20px;
      }

      .back-to-ngs-link {
        margin-left: 20px;
      }
    }

    .mobile-header {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .contact-us-link {
        margin-inline: 0;
      }

      .mobile-header__row-1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        width: 100%;
        border-bottom: 1px solid rgba(28, 36, 51, 0.2);
        padding: 8px 12px;
      }

      .new-search-btn {
        font-size: 16px;
        padding: 10px 16px;
      }
    }
  }
}

.filters-wrapper {
  padding: 12px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid $color-grey-light;

  > *:not(:last-child) {
    border-bottom: 1px solid $color-grey-light;
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
}

.header-ios {
  padding-top: var(--safe-area-inset-top);
}
</style>
